// Angular
import { Component, OnInit } from '@angular/core';
// Models
import { Tournament } from '../../models/tournament';
// Services

import { ApiService } from '../../services/api';
import * as lodash from 'lodash';
import { OAuthService } from '../../services/o-auth';
import { Club } from '../../models/club'
import { AngularFireDatabase } from 'angularfire2/database';
import { ElasticService } from 'app/services/elastic';

@Component({
  templateUrl: './profile-dashboard.component.html'
})
export class ProfileDashboardComponent implements OnInit {
  public user
  public clubCount = 0;
  public userCount = 0;
  public companyCount = 0;

  public activeClubCount = 0;
  public pgaCount = 0;
  public memberCount = 0;

  constructor(private fireDatabase: AngularFireDatabase, private oAuthService: OAuthService, private apiService: ApiService, private elasticService: ElasticService) {

  }



  async ngOnInit() {
    this.user = this.oAuthService.getClub()

    await this.members()

  }

  async members() {
    let data = await this.apiService.list(`/club-members/${this.user.cid}`)
    this.memberCount = data.length
    return
  }
  getAllClub() {
    let promise = new Promise((resolve, reject) => {
      const clubsCount = {
        'index': 'users',
        'type': 'club',
        'size': 1,
        'from': 0,
        'body/query/bool/must/query_string/query': `*`,
        'body/query/bool/must/query_string/fields': [`name^10`]
      };
      this.elasticService.search(clubsCount)
        .then(result => {
          this.clubCount = result.total;
          console.log(result)
          console.log(1)
          resolve(1)
          window.scrollTo(0, 0);
        })
        .catch(error => {
          console.error(error);
        });

    })
    return promise
  }
  getAllComapny() {
    let promise = new Promise((resolve, reject) => {
      const clubsCount = {
        'index': 'users',
        'type': 'company',
        'size': 1,
        'from': 0,
        'body/query/bool/must/query_string/query': `*`,
        'body/query/bool/must/query_string/fields': [`name^10`]
      };
      this.elasticService.search(clubsCount)
        .then(result => {
          this.companyCount = result.total;
          console.log(result)
          console.log(1)
          resolve(1)
          window.scrollTo(0, 0);
        })
        .catch(error => {
          console.error(error);
        });

    })
    return promise
  }
  getActiveClub() {
    let promise = new Promise((resolve, reject) => {
      const queryParams = {
        'index': 'users',
        'type': 'club',
        'size': 1,
        'from': 0,
        'body/query/bool/must/query_string/query': 'true',
        'body/query/bool/must/query_string/fields': [`isVerified^10`]
      };
      this.elasticService.search(queryParams)
        .then(result => {
          this.activeClubCount = result.total;
          console.log(2)

          resolve(2)
          window.scrollTo(0, 0);
        })
        .catch(error => {
          console.error(error);
        });
    })
    return promise

  }
  getUsers() {
    let promise = new Promise((resolve, reject) => {
      const userCount = {
        'index': 'users',
        'type': 'user',
        'size': 1,
        'from': 0,
        'body/query/bool/must/query_string/query': `*`,
        'body/query/bool/must/query_string/fields': [`username^10`]
      };
      this.elasticService.search(userCount)
        .then(result => {
          console.log(result);

          this.userCount = result.total
          console.log(this.userCount)
          window.scrollTo(0, 0);
          console.log(3)

          resolve(3)

        })
        .catch(error => {
          console.error(error);
        });
    })
    return promise
  }
  getPGA() {
    let promise = new Promise((resolve, reject) => {
      const userCount = {
        'index': 'users',
        'type': 'user',
        'size': 1,
        'from': 0,
        'body/query/bool/must/query_string/query': true,
        'body/query/bool/must/query_string/fields': [`isPro`]
      };
      this.elasticService.search(userCount)
        .then(result => {
          this.pgaCount = result.total;
          resolve(4)
          window.scrollTo(0, 0);
        })
        .catch(error => {
          console.error(error);
        });
    })
    return promise
  }
}




